import React from 'react'

// Heading
interface IHeadingProps extends React.HTMLProps<HTMLHeadingElement> {
  level?: 1 | 2 | 3 | 4 | 5 | 6
  skeleton?: boolean
}

const Heading: React.FC<IHeadingProps> = ({
  children,
  level = 1,
  skeleton,
  ...rest
}) => {
  const Component = `h${level}`
  return (
    <div className={`heading ${skeleton ? 'skeleton' : ''}`}>
      <Component {...rest}>{children}</Component>
    </div>
  )
}

// Text
interface ITextProps extends React.HTMLProps<HTMLParagraphElement> {
  variant?: 'default' | 'error' | 'link'
  italic?: boolean
  bold?: boolean
  code?: boolean
  skeleton?: boolean
}

const Text: React.FC<ITextProps> = ({
  children,
  variant = 'default',
  italic,
  bold,
  code,
  skeleton,
  ...rest
}) =>
  code ? (
    <code className='code' {...rest}>
      {children}
    </code>
  ) : (
    <p className={`text-${variant} ${skeleton ? 'skeleton' : ''}`} {...rest}>
      {bold ? (
        italic ? (
          <strong>
            <i>{children}</i>
          </strong>
        ) : (
          <strong>{children}</strong>
        )
      ) : italic ? (
        <i>{children}</i>
      ) : (
        children
      )}
    </p>
  )

// Export
const Typography = {
  Heading,
  Text
}

export default Typography
